require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-introducing-to-rla.json") })
        }
      }, "path---tags-introducing-to-rla");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-introducing-to-rla!./.cache/json/tags-introducing-to-rla.json
// module id = 1512
// module chunks = 231608221292675